export const textureConfig = {
  small: '512px',
  medium: '1k',
  large: '2k',
  'extra-large': '4k',
}
